const tableSelector = ".table--shortened";

const wrapClass = "table--shortened__wrap";
const innerWrapClass = `${wrapClass}-inner`;
const capClass = `${wrapClass}-cap`;
const topCapClass = `${capClass}--top`;
const bottomCapClass = `${capClass}--bottom`;
const topClass = `${wrapClass}--js-at-top`;
const bottomClass = `${wrapClass}--js-at-bottom`;

const scrollChecker = function hideOrShowTableCapOnScroll(elem) {
    const scrollPos = elem.scrollTop;

    if (scrollPos === 0) {
        // Table is scrolled to top
        elem.classList.add(topClass);
    } else {
        elem.classList.remove(topClass);
    }

    if (scrollPos + elem.clientHeight >= elem.scrollHeight) {
        // Table is scrolled to bottom
        elem.classList.add(bottomClass);
    } else {
        elem.classList.remove(bottomClass);
    }

    // Note that the table could be scrolled to BOTH top and bottom at the same
    // time (i.e. few rows & big screen).
};

export default function enhanceShortenedTables() {
    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll(tableSelector).forEach((table) => {
            // Create new elements

            const outerWrapper = document.createElement("div");
            outerWrapper.classList.add(wrapClass, "full");

            const innerWrapper = document.createElement("div");
            innerWrapper.classList.add(innerWrapClass);

            const topCap = document.createElement("div");
            topCap.classList.add(capClass, topCapClass);
            topCap.setAttribute("role", "presentation");
            topCap.ariaHidden = true;

            const bottomCap = document.createElement("div");
            bottomCap.classList.add(capClass, bottomCapClass);
            bottomCap.setAttribute("role", "presentation");
            bottomCap.ariaHidden = true;

            // Arrange new elements
            outerWrapper.append(innerWrapper);
            innerWrapper.append(topCap);
            innerWrapper.append(bottomCap);

            // Add new elements to DOM
            table.after(outerWrapper);

            // Place table in wrapper
            topCap.after(table);

            // Adjust top/bottom shadows immediately, then add listeners to do
            // so on element scroll or window resize
            const boundScrollChecker = scrollChecker.bind(null, innerWrapper);
            boundScrollChecker();
            innerWrapper.addEventListener("scroll", boundScrollChecker);
            window.addEventListener("resize", boundScrollChecker);
        });
    });
}
